import { MenuProps } from './menu_searchfilter-utils';

function menuGuard(
  currentPath: string,
  menuData: MenuProps,
  isLoading: boolean
) {
  if (!isLoading) {
    // @ts-ignore
    for (const menuItem of menuData || []) {
      for (const submenuItem of menuItem?.sub_menu_items || []) {
        if (submenuItem.url === currentPath) {
          return true;
        }
      }
    }
    return false;
  }
}

export default menuGuard;
